<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expenses",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Creditors",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Expenses",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "expdate",
          label: "Date",
          sortable: true,
        },
        {
          key: "tot",
          label: "Total Amount",
          sortable: true,
        },
        {
          key: "paid",
          label: "Amount Paid",
          sortable: true,
        },
        {
          key: "balance",
          label: "Balance",
          sortable: true,
        },
        {
          key: "supplier",
          label: "Supplier",
          sortable: true,
        },
        {
          key: "addedon",
          label: "Added On",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        id: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        mode: "",
        amount: "",
      },
      amountError: "",
      modeError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("expenses", ["Creditors", "SaveStatus"]),
    ...mapGetters("modes", ["Modes"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Creditors ? this.Creditors.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Creditors ? this.Creditors.length : 1;
  },
  methods: {
    ...mapActions({
      FetchCreditors: "expenses/fetchCreditors",
      FetchModes: "modes/fetchModes",
      ClearCredit: "expenses/clearCredit",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Creditors ? this.Creditors.length : 1;
      this.currentPage = 1;
    },
    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },

    showClearModal(values) {
      this.data.id = values.item.id;
      this.data.amount = values.item.balance;
    },
    clearCredit(modal) {
      this.modal = modal;
      this.ClearCredit(this.data);
      this.closeModal(modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchCreditors();
    this.FetchModes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_creditors')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of All Creditors</h3>
              </div>
              <div class="col-3">
                <router-link to="/expenses/view"
                  ><button
                    class="btn btn-success float-end btn-sm"
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('view_expenses')
                      )
                    "
                  >
                    <i class="fa fa-eye"></i> Expenses
                  </button></router-link
                >
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Creditors ? Creditors : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('clear_creditors')
                      )
                    "
                    v-b-modal.clear-modal
                    variant="outline-success"
                    @click="showClearModal(data)"
                    ><i class="fa fa-check"></i> Clear</b-button
                  >
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- edit modal starts -->
      <b-modal
        id="clear-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('clear_creditors')
          )
        "
      >
        <template #modal-title> Clear Credit</template>
        <div class="form-group mb-2">
          <label>Amount <span class="required">*</span></label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount Paid"
              class="form-control"
              @input="resetError(), addCommas()"
              v-model="data.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>
        <div class="form-group mb-2">
          <label>Payment Method <span class="required">*</span></label>
          <div class="input-group">
            <model-list-select
              required
              :list="Modes ? Modes : []"
              v-model="data.mode"
              option-value="id"
              option-text="name1"
              class="mb-2"
              @input="resetError()"
              placeholder="Select Payment Method"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="modeError">
            <em>{{ modeError }}</em>
          </div>
        </div>
        <div class="form-group mb-2">
          <label>Payment Date</label>
          <div class="input-group">
            <input type="date" class="form-control" v-model="data.date" />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('clear-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="clearCredit('clear-modal')"
          >
            <i class="fa fa-check"></i>
            Submit</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
    <!-- modal ends -->
  </Layout>
</template>
<style scoped>
.required {
  color: red;
}
</style>
